module.exports = __webpack_public_path__ + "img/entediada.44eb7678.png";